<div #container
     (cdkDragEnded)="onDragEnded($event)"
     [cdkDragDisabled]="windowRef.draggable === false"
     [ngStyle]="{
     'width': width(),
     'height': height(),
     'minWidth': windowRef.minWidth,
     'minHeight': windowRef.minHeight,
     'maxWidth': windowRef.maxWidth,
     'maxHeight': windowRef.maxHeight
     }"
     cdkDrag
     cdkDragBoundary=".cdk-overlay-container"
     class="mat-elevation-z4 mat-drawer-container z-[1]">
  <div class="flex flex-col h-full max-h-full">

    <div cdkDragHandle class="grow-0 w-full h-[64px] min-h-[64px] cursor-move">
      <rxap-window-tool-bar></rxap-window-tool-bar>
    </div>

    <div class="grow w-full overflow-x-auto overflow-y-hidden" [class.!overflow-y-auto]="!(windowRef.settings$ | async)?.disableVerticalOverflowing">
      <ng-content></ng-content>
    </div>

    <mat-toolbar *ngIf="windowRef.footerPortal$ | async as footerPortal; else closeFooter"
                 class="mat-elevation-z1 grow-0 w-full h-[64px] min-h-[64px]">
      <ng-template [cdkPortalOutlet]="footerPortal"></ng-template>
    </mat-toolbar>
    <ng-template #closeFooter>
      <rxap-window-action-bar (close)="windowRef.complete()"></rxap-window-action-bar>
    </ng-template>

    <mat-progress-bar *ngIf="windowInstance.isLoading$ | async" mode="indeterminate"></mat-progress-bar>

    <rxap-window-resizer [containerRef]="containerRef"></rxap-window-resizer>
  </div>
</div>
